import { render, staticRenderFns } from "./detailDrall.vue?vue&type=template&id=53911b8c&scoped=true"
import script from "./detailDrall.vue?vue&type=script&lang=js"
export * from "./detailDrall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53911b8c",
  null
  
)

export default component.exports